export default "__VITE_ASSET__CGzJCRqe__"